import { withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';
import { sanitize } from 'isomorphic-dompurify';

import { mapSharedPropertiesToFields } from '@gn-audio/jss-components';

import CategoryPromoSlider from './CategoryPromoSlider';
import { CategoryPromoSpotFields, CategoryPromoSpotProps } from './categoryPromoSpotTypes';

const CategoryPromoSpot = ({ fields }: CategoryPromoSpotProps) => {
  const { title, categoryPromoItems } =
    mapSharedPropertiesToFields<CategoryPromoSpotFields>(fields);

  return (
    <div className="container-fluid flex w-full flex-col overflow-hidden">
      <div className="mb-8 text-center">
        <h2 className="heading-2" dangerouslySetInnerHTML={{ __html: sanitize(title.value) }} />
      </div>
      <CategoryPromoSlider items={categoryPromoItems} />
    </div>
  );
};

export default withDatasourceCheck()(CategoryPromoSpot);
